// src/redux/devIntelSlice.js
// Holds live state that comes from socket events (not REST).
// REST data is held by RTK Query in src/api/devIntelApi.js.

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	liveMatchByLead: {}, // { [leadId]: { matchId, count, ts } }
	ingestionFeed: [], // last 50 ingestion events for the toast/banner
	askPending: false,
};

const devIntelSlice = createSlice({
	name: 'devIntel',
	initialState,
	reducers: {
		matchReady(state, action) {
			const { leadId, matchId, count } = action.payload || {};
			if (!leadId) return;
			state.liveMatchByLead[leadId] = { matchId, count, ts: Date.now() };
		},
		ingestionUpdate(state, action) {
			state.ingestionFeed.unshift({ ...action.payload, ts: Date.now() });
			if (state.ingestionFeed.length > 50) state.ingestionFeed.pop();
		},
		askPending(state, action) {
			state.askPending = !!action.payload;
		},
		resetDevIntel() {
			return initialState;
		},
	},
});

export const { matchReady, ingestionUpdate, askPending, resetDevIntel } =
	devIntelSlice.actions;
export default devIntelSlice.reducer;

// ─── Socket wiring helper. Call this once at boot, like registerWhatsappSocket(store). ─
export function registerDevIntelSocket(store, socket) {
	if (!socket) return;
	socket.on('devintel.match.ready', (p) => store.dispatch(matchReady(p)));
	socket.on('devintel.ingestion.update', (p) =>
		store.dispatch(ingestionUpdate(p)),
	);
}
